import React from "react";
import styles from "./ModalLeft.module.css";
import { Modal } from "antd";
import { ReactComponent as CloseIcon } from "../../assets/images/closeIcon.svg";
import SubmitButton from "../submitButton/SubmitButton";

const ModalLeft = ({
    open,
    onCancel,
    className,
    title,
    buttonTitle,
    onBtnPress,
    btnStyle,
    twoButton,
    okBtnTitle,
    cancelBtnTitle,
    onClickOkButton,
    onClickCancelButton,
    leftBtnIcon,
    btnDiv,
    children

}) => {
    return (
        <Modal
            open={open}
            onCancel={onCancel}
            closable={false}
            footer={null}
            className={`${className} ${styles.modalCont}`}
        >
            <div className={styles.modalContent}>
                <div className={styles.modalHead}>
                    <text className={styles.modalHeading}>{title}</text>
                    <CloseIcon style={{cursor:'pointer'}} width={20} height={20} onClick={onCancel} />
                </div>
                {children}

                <div className={styles.modalButtonDiv}>
                    {buttonTitle ? (
                        <SubmitButton
                            primary
                            title={buttonTitle}
                            onClick={onBtnPress}
                            style={btnStyle ? btnStyle : { width: "90%" }}
                        />
                    ) : twoButton ? (
                        <div className={`${btnDiv} ${styles.btnDiv}`}>
                            <SubmitButton
                                leftIcon={leftBtnIcon}
                                title={okBtnTitle}
                                onClick={onClickOkButton}
                                primary
                                style={btnStyle ? btnStyle : { width: "90%" }}
                            />
                            <SubmitButton
                                secondary
                                title={cancelBtnTitle}
                                onClick={onClickCancelButton}
                                style={btnStyle ? btnStyle : { width: "90%" }}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        </Modal>
    );
};

export default ModalLeft;
